import { render } from "./SwiperCarousel.vue?vue&type=template&id=ce3bd3b2"
import script from "./SwiperCarousel.vue?vue&type=script&lang=js"
export * from "./SwiperCarousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__